module.exports = __webpack_public_path__ + "static/media/Slice5.bf999f14.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_174/img/Slice5.png
// module id = 1608
// module chunks = 0